/**
 * Tonalité de retour d'appel jouée par le navigateur.
 *
 * Quand l'opérateur du correspondant n'envoie pas de « early media », Twilio
 * signale la sonnerie (événement `ringing`, hasEarlyMedia=false) mais aucun
 * son n'arrive : l'agent croit que rien ne se passe. Twilio recommande alors
 * de jouer soi-même la tonalité. Cadence française : 440 Hz, 1,5 s de son,
 * 3,5 s de silence. Sans WebAudio (tests, navigateurs restreints) : silence.
 */
let ctx = null;
let timer = null;
let osc = null;

function beep(durationMs) {
  if (!ctx) return;
  try {
    osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine"; osc.frequency.value = 440;
    gain.gain.value = 0.08;
    osc.connect(gain); gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + durationMs / 1000);
  } catch { /* contexte fermé */ }
}

export function startRingback() {
  if (timer) return;
  const AC = typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
  if (!AC) return;
  try { ctx = ctx || new AC(); if (ctx.state === "suspended") ctx.resume?.(); } catch { return; }
  beep(1500);
  timer = setInterval(() => beep(1500), 5000);
}

export function stopRingback() {
  if (timer) { clearInterval(timer); timer = null; }
  try { osc?.stop(); } catch { /* déjà arrêté */ }
  osc = null;
}

export const isRingingBack = () => timer !== null;
